/**
 * Deterministic `trips/{tripId}/bookings/{id}` for Smart Upload cost lines so
 * re-confirming the same parsed row upserts instead of multiplying budget rows.
 */

function sanitizeDocSegment(s: string, maxLen: number): string {
  return s.replace(/[^a-zA-Z0-9_-]/g, '').slice(0, maxLen);
}

function simpleHash16(input: string): string {
  let h1 = 5381;
  let h2 = 52711;
  for (let i = 0; i < input.length; i++) {
    h1 = ((h1 << 5) + h1) ^ input.charCodeAt(i);
    h2 = ((h2 << 5) + h2) ^ (input.charCodeAt(i) * 131);
  }
  return `${(h1 >>> 0).toString(16).padStart(8, '0')}${(h2 >>> 0).toString(16).padStart(8, '0')}`.slice(0, 32);
}

/**
 * Stable booking doc id per trip + Smart Upload review row id (`${jobId}-${idx}`).
 */
export function smartUploadBookingDocId(tripId: string, stableLineId: string): string {
  const h = sanitizeDocSegment(simpleHash16(`${tripId}|${stableLineId}`), 48);
  return `b_su_${h}`;
}
